import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';

import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/index.css';

import App from './app/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
